var units = new Object();
var app = (function( $, Ext, window, undefined ){
    var public = new Object();
	
	public = {
		config: null,
		ckfinder: '../../assets/vendor/cksource/ckfinder'
	};
	
    public.init = function(){
		this.config = utils.parseJSON(Ext.getDom('app-data').innerHTML);
		
		utils.http.init();
		
		toastr.options = {
		  "closeButton": true,
		  "debug": false,
		  "progressBar": false,
		  "positionClass": "toast-top-right",
		  "preventDuplicates": false,
		  "onclick": null,
		  "showDuration": "300",
		  "hideDuration": "1000",
		  "timeOut": "5000",
		  "extendedTimeOut": "1000",
		  "showEasing": "swing",
		  "hideEasing": "linear",
		  "showMethod": "fadeIn",
		  "hideMethod": "fadeOut"
		};	
		
		$(document).on('mouseover', '.fancybox', function() {
			top.$(this).fancybox({
				'opacity'        : true,
				'overlayShow'    : false,
				'transitionIn'    : 'elastic',
				'transitionOut'    : 'none'
			});
		});

		// Ext.Ajax.on('beforerequest', function(conn, options) {
		// 	console.log(arguments);
		// } );

		Ext.Ajax.extraParams = { lang: top.app.config.lang};
    };
		
    return public;
}( jQuery, Ext, window ));

Ext.onReady(app.init, app);


